import { Component, OnDestroy, OnInit } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { filter, Subscription } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import { BreadCrumbsService } from './_shared/services/breadcrumbs.service';
import { SessionService } from './_shared/services/session.service';

// import { HeaderComponent } from './_layout/header/header.component';
// import { SidebarComponent } from './_layout/sidebar/sidebar.component';
// import { BreadcrumbsComponent } from './_shared/components/breadcrumbs.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  // standalone: true,
  // imports: [HeaderComponent, SidebarComponent, BreadcrumbsComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  currentUser = null;
  currentMenu = '';
  // breadcrumbs = [];

  private $currentUserSubs: Subscription; // Use Subscription when we need some data inside, do not forget to unsubscribe
  // currentUser$: Observable<any>; // When we use async() in the html - not need to subscribe / subscribe

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private translateService: TranslateService,
    private upgrade: UpgradeModule,
    private breadCrumbsService: BreadCrumbsService,
    private sessionService: SessionService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translateService.setDefaultLang('en');
  }

  ngOnInit() {
    // Important
    this.$currentUserSubs = this.sessionService.currentUser$.subscribe((data) => {
      this.currentUser = data;
    });

    // When we use async() in the html - not need to subscribe / subscribe
    // this.currentUser$ = this.sessionService.currentUser$.subscribe();

    // In case the user reload the page
    if (!this.translateService.currentLang && this.sessionService.getUserLanguage().code) {
      this.sessionService.setCurrentTranslationLanguage(this.sessionService.getUserLanguage().code);
    }

    // this.titleService.boot();

    this.setTitleMenuBreadcrumb();

    this.upgrade.bootstrap(document.body, ['app']);
  }

  ngOnDestroy(): void {
    // Optional about unsubscribing from the observable here because it's the root component of the application
    // the only time the component will be destroyed is when the application is closed
    // which would destroy any subscriptions as well.

    this.$currentUserSubs.unsubscribe();
  }

  private setTitleMenuBreadcrumb() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let child = this.activatedRoute.firstChild;

      if (!child) return; // Remove after full migration

      // For lazy loading
      while (child.firstChild) {
        child = child.firstChild;
      }

      const title = child.snapshot.data['title'];

      // Title
      if (title) {
        this.title.setTitle(this.translateService.instant(title));
      }

      // Menu
      this.currentMenu = '';

      const menu = child.snapshot.data['menu'];

      if (menu) {
        // We can emit and event here and the sidebar can subscribe to an observable
        this.currentMenu = menu;
      }

      // Breadcrumbs
      const breadcrumbs = [];
      const breadcrumb = child.snapshot.data['breadcrumb'];

      if (breadcrumb) {
        breadcrumbs.push({
          label: breadcrumb.label,
          parent: breadcrumb.parent,
        });
      }

      this.breadCrumbsService.setBreadCrumbs(breadcrumbs);
    });
  }
}

// this.translateService.get(title).subscribe((tlt) => {
//   this.title.setTitle(tlt);
// });

// Breadcrumbs
// this.breadcrumbs = [];

// let breadcrumb = child.snapshot.data['breadcrumb'];

// if (breadcrumb) {
//   this.breadcrumbs.push({
//     label: breadcrumb.label,
//     parent: breadcrumb.parent,
//   });
// }

// import { TitleService } from './_shared/services/NO-YET-title.service';
// private titleService: TitleService,

// import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
// import { filter, map, Observable, Subscription } from 'rxjs';
// import { Title } from '@angular/platform-browser';

/*let appTitle = this.titleService.getTitle();

    // Eager routing
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;

          if (!child) return ''; // Remove after full migration

          const child = this.activatedRoute.firstChild;

          if (child.snapshot.data['title']) {
            this.translateService.get(child.snapshot.data['title']).subscribe((title) => {
              // return title;
              appTitle = title;
            });
          }

          return appTitle;

          

          while (child.firstChild) {
            child = child.firstChild;
          }

          if (child.snapshot.data['title']) {
            this.translateService.get(child.snapshot.data['title']).subscribe((title) => {
              // return title;
              appTitle = title;
            });

            // return child.snapshot.data['title'];
          }

          return appTitle;
        })
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title);
      });
*/

// this.$currentUserSubs = this.sessionService.getCurrentUserSubjectValue().subscribe((data) => {
//   this.currentUser = data;
// });

// private $currentUserLangSubs: Subscription;
// this.$currentUserLangSubs = this.sessionService
//   .getCurrentUserLangSubjectValue()
//   .subscribe((data) => {
//     // this.currentUser = data;
//     console.log(data);
//   });
// this.$currentUserLangSubs.unsubscribe();

// Lazy loading
/* this.router
        .events.pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => {
            let child = this.activatedRoute.firstChild;
            
            while (child.firstChild) {
              child = child.firstChild;
            }

            if (child.snapshot.data['title']) {
              return child.snapshot.data['title'];
            }

            return appTitle;
          })
        ).subscribe((title: string) => {
          this.titleService.setTitle(title);
        }); */

// this.router.events
//   .pipe(filter((event) => event instanceof NavigationEnd))
//   .subscribe((event: NavigationEnd) => {
//     console.log(event);

//     if (data) {
//       this.titleService.setTitle(data + ' - Website Name');
//   }

// console.log(this.route);

// console.log(this.route.root.firstChild.snapshot.data);

// this.path = event.url.substring(1).split('/');  //  URL => stackOverflow
// this.pathTitle = this.route.root.firstChild.snapshot.data.title; // data.title => stack Overflow
// });

// console.log(this.route.snapshot.data);

// this.route.data.subscribe((v) => {
//   console.log(v);
// });
